const EmergencyLighting = {
    title: "New Emergency Lighting",
};
export default EmergencyLighting;
